"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnceAsync = exports.useOnce = void 0;
const react_1 = require("react");
function useOnce(effect) {
    return react_1.useEffect(effect, []);
}
exports.useOnce = useOnce;
function useOnceAsync(effect) {
    return useOnce(() => {
        effect();
    });
}
exports.useOnceAsync = useOnceAsync;
//# sourceMappingURL=use-once.js.map